import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var menu_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M5 5v1.5h14V5H5zm0 7.8h14v-1.5H5v1.5zM5 19h14v-1.5H5V19z" }) });
export {
  menu_default as default
};
//# sourceMappingURL=menu.js.map
